export default {
      id: "i-time-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/sprite.svg#i-time",
      toString: function () {
        return this.url;
      }
    }